module.exports = __webpack_public_path__ + "static/media/heartipro-charger-3.65541015.png";